import React, { useState, useCallback } from 'react'
import { useCQuery } from '../../Services'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import PeopleIcon from '@mui/icons-material/People'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import { UsersTable } from './UsersTable'
import { UserDialog } from './UserDialog'
import { DeleteDialog } from './DeleteDialog'

export const Users = () => {
  const { data: users = [], isSuccess: isSuccessUsers } = useCQuery('users')
  const { data: agencies = [], isSuccess: isSuccessAgencies } = useCQuery('agencies')

  const [isUserDialogOpen, setIsUserDialogOpen] = useState(false)
  const [editingUser, setEditingUser] = useState(null)
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
  const [deletingUser, setDeletingUser] = useState(null)

  const loggedInUser = JSON.parse(window.localStorage.getItem('user'))?.user
  const isAdmin = loggedInUser?.role === 'siapAdmin'
  const canEdit = isAdmin

  const handleOpenCreate = useCallback(() => {
    setEditingUser(null)
    setIsUserDialogOpen(true)
  }, [])

  const handleOpenEdit = useCallback((user) => {
    setEditingUser(user)
    setIsUserDialogOpen(true)
  }, [])

  const handleCloseUserDialog = useCallback(() => {
    setIsUserDialogOpen(false)
    setEditingUser(null)
  }, [])

  const handleOpenDelete = useCallback((user) => {
    setDeletingUser(user)
    setIsDeleteDialogOpen(true)
  }, [])

  const handleCloseDelete = useCallback(() => {
    setIsDeleteDialogOpen(false)
    setDeletingUser(null)
  }, [])

  if (!isSuccessUsers || !isSuccessAgencies) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <Stack alignItems='center' spacing={2}>
          <CircularProgress size={40} />
          <Typography variant='body2' color='text.secondary'>
            Caricamento utenti...
          </Typography>
        </Stack>
      </Box>
    )
  }

  return (
    <Box sx={{ mx: 'auto', width: '94%', maxWidth: 1600, pb: 5 }}>
      <UserDialog
        open={isUserDialogOpen}
        onClose={handleCloseUserDialog}
        user={editingUser}
        agencies={agencies}
      />

      <DeleteDialog
        open={isDeleteDialogOpen}
        onClose={handleCloseDelete}
        user={deletingUser}
      />

      {/* Page Header */}
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={{ mb: 2, mt: 1 }}
      >
        <Stack direction='row' alignItems='center' spacing={2}>
          <PeopleIcon color='primary' sx={{ fontSize: 28 }} />
          <Typography variant='h5' fontWeight={700} color='text.primary'>
            Gestione Utenti
          </Typography>
          <Chip
            label={`${users.length} utent${users.length === 1 ? 'e' : 'i'}`}
            size='small'
            variant='outlined'
            sx={{ fontWeight: 500 }}
          />
        </Stack>

        {canEdit && (
          <Button
            variant='contained'
            startIcon={<PersonAddIcon />}
            onClick={handleOpenCreate}
            sx={{ textTransform: 'none', fontWeight: 600 }}
          >
            Nuovo Utente
          </Button>
        )}
      </Stack>

      {/* Users Table */}
      <Paper
        elevation={0}
        sx={{
          p: 2,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2
        }}
      >
        <UsersTable
          users={users}
          agencies={agencies}
          isAdmin={isAdmin}
          canEdit={canEdit}
          onEdit={handleOpenEdit}
          onDelete={handleOpenDelete}
        />
      </Paper>
    </Box>
  )
}
